import { Context, createContext } from 'react'
import { RootStore } from './root-store'

const RootStoreContext: Context<RootStore> = createContext<RootStore>({} as any)

export { RootStoreContext }
